export enum MappingFilter {
    All = 'all',
    Corrected = 'corrected',
    Invalid = 'invalid',
    Predicted = 'predicted',
    Selected = 'selected',
    Unidentified = 'unidentified',
}
